<template>
  <span
    class="iconfont-wrapper"
    :class="{ reverse }"
    :style="{
      ...customStyle,
      '--icon-gap': gap,
      '--icon-reverse-font-size': reverseFontSize
    }"
  >
    <!-- 动态调整图标和文字的顺序 -->
    <template v-if="reverse">
      <span v-if="$slots.default" class="iconfont-text">
        <slot></slot>
      </span>
    </template>

    <!-- 核心修改1：区分 Symbol/Font-class 模式，支持多色图标 -->
    <template v-if="useSymbol">
      <svg
        class="iconfont-svg"
        :style="{ width: size, height: size, color: color }"
        aria-hidden="true"
      >
        <use :xlink:href="`#icon-${type}`"></use>
      </svg>
    </template>
    <template v-else>
      <i
        class="iconfont"
        :class="`icon-${type}`"
        :style="{ fontSize: size, color: color }"
      ></i>
    </template>

    <template v-if="!reverse">
      <span v-if="$slots.default" class="iconfont-text">
        <slot></slot>
      </span>
    </template>
  </span>
</template>

<script setup lang="ts">
defineProps({
  type: { type: String, required: true }, // 图标名
  size: { type: String, default: '14px' }, // 尺寸（支持px/rem/em）
  color: { type: String, default: 'inherit' }, // 颜色（Symbol模式下多色图标会保留原有渐变）
  customStyle: { type: Object, default: () => ({}) }, // 自定义样式
  gap: { type: String, default: '8px' }, // 图标和文字间距
  reverse: { type: Boolean, default: false }, // 图标/文字顺序反转
  useSymbol: { type: Boolean, default: false }, // 关键：是否使用Symbol模式（支持多色）
  reverseFontSize: { type: String, default: '11px' } // 反向时的文字大小
})
</script>

<style scoped lang="scss">
.iconfont-wrapper {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  // 核心修改2：统一控制间距和文字大小（避免变形）
  .iconfont-text {
    margin-left: var(--icon-gap);
    font-size: inherit; // 继承容器字体大小，避免强制覆盖
  }

  &.reverse {
    .iconfont-text {
      margin-left: 0;
      margin-right: var(--icon-gap);
      font-size: var(--icon-reverse-font-size) !important; // 用CSS变量更灵活
    }
  }

  // 核心修改3：Symbol模式下的SVG样式（保证图标不变形）
  .iconfont-svg {
    width: 1em;
    height: 1em;
    fill: currentColor; // 单色时继承color，多色时保留原有样式
    overflow: hidden;
    vertical-align: -0.15em; // 视觉居中对齐
  }

  // Font-class模式样式（兼容原有逻辑）
  .iconfont {
    display: inline-block;
    vertical-align: middle; // 对齐SVG模式的垂直位置
  }
}
</style>
